import { SHButton, SHDialog, SHStack } from "@components/design-systems";

interface SubmitForReviewDialogProps {
  onClose?: () => void;
  onSubmit?: () => void;
  isSubmitting?: boolean;
}

const SubmitForReviewDialog = ({
  onClose,
  onSubmit,
  isSubmitting = false,
}: SubmitForReviewDialogProps) => {
  return (
    <SHDialog
      open
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth={false}
      sx={{
        "& .MuiPaper-root": {
          width: { xs: "100%", md: 658 },
        },
      }}
      header="Submit your changes?"
      body="Submitting your changes will freeze this platform profile. You will not be able to make additional changes while your submission is with the SuitabilityHub team for review."
      footer={
        <SHStack
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={7}
        >
          <SHButton
            color="secondary"
            variant="text"
            size="extraMedium"
            onClick={onClose}
            disabled={isSubmitting}
          >
            No, I’ll have another look
          </SHButton>
          <SHButton
            color="primary"
            size="extraMedium"
            variant="contained"
            onClick={onSubmit}
            disabled={isSubmitting}
            isLoading={isSubmitting}
          >
            Yes, submit my changes
          </SHButton>
        </SHStack>
      }
    />
  );
};

export default SubmitForReviewDialog;
